import { render, staticRenderFns } from "./WindowsSync.vue?vue&type=template&id=58d5bc96&scoped=true"
import script from "./WindowsSync.vue?vue&type=script&lang=js"
export * from "./WindowsSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d5bc96",
  null
  
)

export default component.exports